@if (this.fusionService.selectedMiroByUrl && this.fusionService.selectedMiroByUrl.metadata.boardId) {
  <div class="fusion-container">
    <!-- ===== INTRO ===== -->
    <div class="fusion-intro">
      <div class="fusion-logo-icon">
        <i class="ri-artboard-2-line"></i>
      </div>
      <div>
        <h5
          class="mb-0"
          i18n="@@miro-by-url"
        >Miro: Board von URL</h5>
        <small
          class="text-muted"
          i18n="@@miro-by-url-intro-description"
          >
          Verbinde ein Miro-Board per URL mit diesem Fusion-View.
        </small>
      </div>
    </div>
    <hr class="fusion-divider" />
    <!-- ===== TITEL + IDENTIFIKATOR ===== -->
    <section class="fusion-section">
      <h6
        class="fusion-section-title"
        i18n="@@title"
      >Titel</h6>
      <input
        pInputText
        type="text"
        [(ngModel)]="this.fusionService.selectedMiroByUrl.metadata.title"
        [ngModelOptions]="{ updateOn: 'blur' }"
        (ngModelChange)="this.fusionService.updateFusionFieldFor(this.fusionService.selectedMiroByUrl._id, 'title', this.fusionService.selectedMiroByUrl.metadata.title)"
        class="w-100"
        >
      <small class="fusion-section-hint mt-1 d-block">
        <span i18n="@@fusion-view-name">Identifikator</span>: {{ this.fusionService.selectedMiroByUrl.metadata.name }}
      </small>
    </section>
    <hr class="fusion-divider" />
    <div class="fusion-sections">
      <!-- ===== 1. BOARD-URL + OPTIONEN ===== -->
      <section class="fusion-section">
        <h6
          class="fusion-section-title"
          i18n="@@fusion-view-board-url"
        >Board-URL</h6>
        <div class="video-url-row">
          @if (!this.idInvalid) {
            <div class="video-preview">
              <iframe [src]="this.iframeUrl"></iframe>
            </div>
          }
          <div class="video-url-controls">
            @if (this.idInvalid) {
              <div class="d-flex gap-2 align-items-start mb-3">
                <input
                  pInputText
                  pSize="small"
                  class="flex-fill"
                  [(ngModel)]="this.fusionService.selectedMiroByUrl.metadata.boardId"
                  [ngModelOptions]="{updateOn: 'blur'}"
                  (ngModelChange)="this.boardUrlInputChange($event)"
                  placeholder="https://miro.com/app/board/..."
                  >
              </div>
            } @else {
              <div class="d-flex gap-2 align-items-start mb-3">
                <input
                  pInputText
                  pSize="small"
                  class="flex-fill"
                  [readonly]="true"
                  [value]="'https://miro.com/app/board/' + this.fusionService.selectedMiroByUrl.metadata.boardId + '/'"
                  >
                <p-button
                  size="small"
                  severity="secondary"
                  icon="ri-close-line"
                  (onClick)="this.boardUrlInputChange('')"
                ></p-button>
              </div>
            }
            <!-- Board-Einstellungen -->
            <h6
              class="fusion-section-title mt-2"
              i18n="@@miro-board-settings"
            >Board-Einstellungen</h6>
            <div class="d-flex flex-column gap-3">
              <!-- Bearbeitbar -->
              <div class="display-option-toggle">
                <p-toggleswitch
                  [ngModel]="this.fusionService.selectedMiroByUrl.metadata.editadble"
                  (ngModelChange)="this.fusionService.selectedMiroByUrl.metadata.editadble = $event; this.fusionService.updateFusionField('editadble', $event); this.setIframeUrlFromSettings()"
                ></p-toggleswitch>
                <label
                  class="form-label fw-semibold mb-0"
                  i18n="@@fusion-view-miro-editable"
                >Bearbeitbar</label>
              </div>
              <!-- Autoplay -->
              <div class="display-option-toggle">
                <p-toggleswitch
                  [ngModel]="this.fusionService.selectedMiroByUrl.metadata.autoplay"
                  (ngModelChange)="this.fusionService.selectedMiroByUrl.metadata.autoplay = $event; this.fusionService.updateFusionField('autoplay', $event); this.setIframeUrlFromSettings()"
                ></p-toggleswitch>
                <label
                  class="form-label fw-semibold mb-0"
                  i18n="@@fusion-view-miro-autoplay"
                >Automatisch abspielen</label>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr class="fusion-divider" />
      <!-- ===== 2. DARSTELLUNGSOPTIONEN (INITIAL) + PREVIEW ===== -->
      <section class="fusion-section">
        <h6
          class="fusion-section-title"
          i18n="@@fusionconfig-display-options"
        >Darstellungsoptionen (Initial)</h6>
        <small
          class="fusion-section-hint"
          i18n="@@fusionconfig-display-options-hint"
          >
          Lege fest, wie der Bot und der Inhalt im Fusion-View dargestellt werden.
        </small>
        <div class="display-options-row">
          <div class="display-options-controls">
            <!-- Ansichtsmodus -->
            <div class="display-option-field">
              <p-select
                [options]="this.viewModeOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="this.fusionService.selectedMiroByUrl.metadata.viewMode"
                [ngModelOptions]="{updateOn: 'blur'}"
                (ngModelChange)="this.fusionService.updateFusionField('viewMode', this.fusionService.selectedMiroByUrl.metadata.viewMode)"
              ></p-select>
            </div>
            <!-- Bot-Typ -->
            <div class="display-option-field">
              <p-selectbutton
                [options]="this.botTypeOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="this.fusionService.selectedMiroByUrl.metadata.bottype"
                (ngModelChange)="this.fusionService.updateFusionField('bottype',this.fusionService.selectedMiroByUrl.metadata.bottype)"
                [unselectable]="true"
                >
                <ng-template
                  let-item
                  pTemplate="item"
                  >
                  <i
                    [class]="item.icon"
                    class="me-1"
                  ></i>
                  <span>{{ item.label }}</span>
                </ng-template>
              </p-selectbutton>
            </div>
            <!-- Bot anzeigen -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="!this.fusionService.selectedMiroByUrl.metadata.botHidden"
                (ngModelChange)="this.fusionService.selectedMiroByUrl.metadata.botHidden = !$event; this.fusionService.updateFusionField('botHidden', this.fusionService.selectedMiroByUrl.metadata.botHidden)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@fusionconfig-bot-visible"
              >Bot anzeigen</label>
            </div>
            <!-- Bot-Button anzeigen -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="!this.fusionService.selectedMiroByUrl.metadata.botButtonHidden"
                (ngModelChange)="this.fusionService.selectedMiroByUrl.metadata.botButtonHidden = !$event; this.fusionService.updateFusionField('botButtonHidden', this.fusionService.selectedMiroByUrl.metadata.botButtonHidden)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@fusionconfig-bot-button-visible"
              >Bot-Button anzeigen</label>
            </div>

            <!-- Disclaimer-Platzierung -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="this.fusionService.selectedMiroByUrl.metadata.disclaimerPlacement === 'fusionview'"
                (ngModelChange)="this.fusionService.selectedMiroByUrl.metadata.disclaimerPlacement = $event ? 'fusionview' : 'botview'; this.fusionService.updateFusionField('disclaimerPlacement', this.fusionService.selectedMiroByUrl.metadata.disclaimerPlacement)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@fusionconfig-disclaimer-over-fusionview"
              >Disclaimer über Fusion-View</label>
            </div>

            <!-- Systemsprache -->
            <div class="display-option-toggle">
              <label
                class="form-label fw-semibold mb-0"
                for="miroUrlLangSelect"
                i18n="@@fusionconfig-systemlang"
              >Systemsprache</label>
              <p-select
                id="miroUrlLangSelect"
                [options]="this.systemLanguageOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="this.fusionService.selectedMiroByUrl.metadata.botlang"
                (ngModelChange)="this.fusionService.updateFusionField('botlang', this.fusionService.selectedMiroByUrl.metadata.botlang)"
              ></p-select>
            </div>
          </div>
          <!-- Preview Wireframe -->
          <div class="display-preview">
            <div class="display-preview-frame">
              @if (this.fusionService.selectedMiroByUrl.metadata.viewMode === 'split' || !this.fusionService.selectedMiroByUrl.metadata.viewMode) {
                <div class="preview-split">
                  <div class="preview-content-area">
                    <div class="preview-content-line"></div>
                    <div class="preview-content-line short"></div>
                    <div class="preview-content-line"></div>
                  </div>
                  @if (!this.fusionService.selectedMiroByUrl.metadata.botHidden) {
                    <div
                      class="preview-bot-area"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                </div>
              }
              @if (this.fusionService.selectedMiroByUrl.metadata.viewMode === 'split-reverse') {
                <div class="preview-split-reverse">
                  <div class="preview-content-area">
                    <div class="preview-content-line"></div>
                    <div class="preview-content-line short"></div>
                    <div class="preview-content-line"></div>
                  </div>
                  @if (!this.fusionService.selectedMiroByUrl.metadata.botHidden) {
                    <div
                      class="preview-bot-area"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                </div>
              }
              @if (this.fusionService.selectedMiroByUrl.metadata.viewMode === 'window') {
                <div class="preview-window">
                  <div class="preview-content-area full">
                    <div class="preview-content-line"></div>
                    <div class="preview-content-line short"></div>
                  </div>
                  @if (!this.fusionService.selectedMiroByUrl.metadata.botHidden) {
                    <div
                      class="preview-bot-overlay"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                </div>
              }
              @if (this.fusionService.selectedMiroByUrl.metadata.viewMode === 'full') {
                <div class="preview-full">
                  @if (!this.fusionService.selectedMiroByUrl.metadata.botHidden) {
                    <div
                      class="preview-bot-area fullscreen"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                        <div class="preview-bot-bubble"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                  @if (this.fusionService.selectedMiroByUrl.metadata.botHidden) {
                    <div
                      class="preview-hidden-label"
                      i18n="@@fusionconfig-preview-hidden"
                    >Bot ausgeblendet</div>
                  }
                </div>
              }
              @if (this.fusionService.selectedMiroByUrl.metadata.viewMode === 'float') {
                <div class="preview-float">
                  <div class="preview-content-area full">
                    <div class="preview-content-line"></div>
                    <div class="preview-content-line short"></div>
                    <div class="preview-content-line"></div>
                  </div>
                  @if (!this.fusionService.selectedMiroByUrl.metadata.botHidden) {
                    <div
                      class="preview-bot-float"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                </div>
              }
              @if (this.fusionService.selectedMiroByUrl.metadata.botHidden && this.fusionService.selectedMiroByUrl.metadata.viewMode !== 'full') {
                <div
                  class="preview-hidden-overlay"
                  >
                  <div class="preview-content-line"></div>
                  <div class="preview-content-line short"></div>
                  <div class="preview-content-line"></div>
                </div>
              }
              @if (!this.fusionService.selectedMiroByUrl.metadata.botButtonHidden) {
                <div
                  class="preview-bot-fab"
                  >
                  <i class="ri-chat-3-line"></i>
                </div>
              }
            </div>
          </div>
        </div>
      </section>
      <hr class="fusion-divider" />
      <!-- ===== 3. LOGIK-EDITOR ===== -->
      <section class="fusion-section">
        <h6
          class="fusion-section-title"
          i18n="@@fusion-logic-editor-heading"
        >Logik-Editor</h6>
        <p
          class="fusion-section-hint"
          i18n="@@fusion-logic-editor-description"
          >
          Im Logik-Editor kannst du Abläufe und Regeln für diesen Fusion-View per Scripting anpassen.
        </p>
        <p-button
          [outlined]="true"
          severity="primary"
          size="small"
          icon="ri-code-box-line"
          [gotoBlockly]="this.editorItemsService.getEditorItemByUniqueId('fusion_'+this.fusionService.selectedMiroByUrl._id)"
          i18n-label="@@to-scripting"
          label="Zum Scripting"
        ></p-button>
      </section>
    </div>
  </div>
}

@if (this.fusionService.selectedMiroByUrl && !this.fusionService.selectedMiroByUrl.metadata.boardId) {
  <div class="fusion-container">
    <div class="video-empty">
      <div class="video-empty-icon">
        <i class="ri-artboard-2-line"></i>
      </div>
      <h5
        class="mb-1"
        i18n="@@embed-miro-board"
      >Miro-Board einbinden</h5>
      <small
        class="text-muted mb-3 d-block text-center"
        i18n="@@embed-miro-board-description"
        >
        Füge eine Miro-Board-URL ein, um das Board mit diesem Fusion-View zu verbinden.
      </small>
      <div class="video-empty-input">
        <input
          pInputText
          #emptyUrlInput
          type="text"
          class="flex-fill"
          placeholder="https://miro.com/app/board/..."
          />
        <p-button
          size="small"
          severity="primary"
          (onClick)="this.boardUrlInputChange(emptyUrlInput.value)"
          i18n-label="@@use"
          label="Verwenden"
        ></p-button>
      </div>
    </div>
  </div>
}
